export const genarateNavbarSubSlug = (str) => {
    return str.split(" ").map(el => el.toLowerCase()).join("-");
}